export default {
  title: "403 Verboten",
  description:
    "Leider haben Sie keine Berechtigung, auf diese Seite zuzugreifen. Bitte wenden Sie sich an Ihren Administrator, wenn Sie der Meinung sind, dass dies ein Fehler ist.",
  goHome: "Zur Startseite gehen",
  goBack: "Zurückgehen",
};
